export * from './svg-icon-registry';
export * from './svg-icon.component';
export * from './svg-icon.module';
